import {apsViewModels} from "../shared/dto/APS.ViewModels";
import {apsCommands} from "../shared/dto/aps.commands";
import * as angular from 'angular';
import UserServiceName, {UserService} from "../services/users/user.service";

export interface UserProfile {
  read: () => angular.IPromise<apsViewModels.UserProfileData>;
  update: (data: apsViewModels.UserProfileData) => void;
  updateEditProfile: (data: apsCommands.EditUserProfile) => void;
}

export default angular.module('userProfile', [UserServiceName])
  .factory('userProfile',function($q: angular.IQService,
                                  userService: UserService) {
    let vm = this as UserProfile;

    let data: apsViewModels.UserProfileData = null;
    let promise: angular.IPromise<apsViewModels.UserProfileData> = null;

    vm.read = () => {
      if (data) {
        return $q.when(data);
      }

      if (promise) {
        return promise;
      }

      promise = userService.getUserProfile()
        .then<apsViewModels.UserProfileData>((userData) => {
          data = userData;
          promise = null;
          return data;
        });

      return promise;
    };

    vm.update = (userData: apsViewModels.UserProfileData) => {
      data = userData;
    };
    
    vm.updateEditProfile = (userData: apsCommands.EditUserProfile) => {
      data.displayDefectsByNumber = userData.displayDefectsByNumber;
      data.email = userData.email;
      data.phoneNumber = userData.phoneNumber;
    };

    return vm;
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/models/userProfile.ts